var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 19.5,
    rx: 9.75,
    stroke: "#C6C4C4",
    strokeOpacity: 0.77,
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3942_10730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22879 8.19047L9.87164 9.97619C9.91314 9.99188 9.95639 9.9999 10 9.9999C10.0436 9.9999 10.0868 9.99188 10.1284 9.97619L14.7712 8.19047C14.909 8.13745 15 8.00492 15 7.85704C15 7.70917 14.909 7.57663 14.7712 7.52361L10.1284 5.7379C10.0454 5.70651 9.95466 5.70651 9.87166 5.7379L5.2288 7.52361C5.09104 7.57663 5 7.70917 5 7.85704C5 8.00492 5.09104 8.13745 5.22879 8.19047ZM10 6.45394L13.6478 7.85704L10 9.26015L6.3522 7.85704L10 6.45394Z",
    fill: "#81827E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7712 11.5969L13.7476 11.2031L12.7525 11.5861L13.6478 11.9303L10 13.3334L6.3522 11.9303L7.2475 11.5861L6.25245 11.2031L5.2288 11.5969C5.09104 11.6499 5 11.7824 5 11.9303C5 12.0782 5.09104 12.2107 5.22879 12.2637L9.87164 14.0495C9.91314 14.0652 9.95639 14.0732 10 14.0732C10.0436 14.0732 10.0868 14.0652 10.1284 14.0495L14.7712 12.2637C14.909 12.2107 15 12.0782 15 11.9303C15 11.7824 14.909 11.6499 14.7712 11.5969Z",
    fill: "#81827E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7712 9.56027L13.7476 9.1665L12.7525 9.54945L13.6478 9.8937L10 11.2968L6.3522 9.8937L7.2475 9.54947L6.25245 9.16652L5.2288 9.56029C5.09104 9.61329 5 9.74583 5 9.8937C5 10.0416 5.09104 10.1741 5.22879 10.2271L9.87164 12.0128C9.91314 12.0285 9.95639 12.0366 10 12.0366C10.0436 12.0366 10.0868 12.0285 10.1284 12.0128L14.7712 10.2271C14.909 10.1741 15 10.0416 15 9.8937C15 9.74583 14.909 9.61329 14.7712 9.56027Z",
    fill: "#81827E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3942_10730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon1);
export default __webpack_public_path__ + "static/media/peopleIcon1.1f393efcf86e8eeff7773610b343dc74.svg";
export { ForwardRef as ReactComponent };